import React, { useRef } from 'react';
import { FieldProps, useField } from 'formik';
import clsx from 'clsx';
import classes from './NormalInput.module.css';

interface CustomProps {
  divClassName?: string;
  labelClassName?: string;
}

type NormalInputFieldProps = CustomProps & FieldProps & React.HTMLProps<HTMLInputElement>;

function NormalInput({
  label,
  type,
  divClassName,
  labelClassName,
  className,
  children,
  field,
  ...props
}: NormalInputFieldProps) {
  const input = useRef<HTMLInputElement | any>(null);
  const [fieldData, meta] = useField(field.name);

  const handleOnClickLabel = (e: any) => {
    e.preventDefault();
    if (fieldData.value === '' && input !== undefined) {
      input?.current.focus();
    }
  };

  return (
    <div className={clsx(classes.InputDiv, divClassName)}>
      <input
        ref={input}
        type={type}
        className={clsx(classes.Input, className, meta.error && meta.touched && classes.InputError)}
        placeholder=" "
        {...field}
        {...props}
      />
      <label className={clsx(classes.Label, labelClassName)} onClick={(e) => handleOnClickLabel(e)}>
        {label}
      </label>
      {meta.error && meta.touched && <span className={classes.TextError}>{meta.error}</span>}
      {children}
    </div>
  );
}

export default NormalInput;
